import React, { useState } from 'react'
import PageContainer from '../../Components/PageContainer'
import { AuthErrorCodes, createUserWithEmailAndPassword, FacebookAuthProvider, GoogleAuthProvider, sendEmailVerification, signInWithPopup, TwitterAuthProvider, updateProfile } from "firebase/auth";
import { auth, firestore } from '../../firebase';
import { useNavigate } from 'react-router';
import { doc, getDoc, setDoc, updateDoc } from 'firebase/firestore';
import { checkForBannedAddress } from '../../Helpers/bannedAddressCheck';
import cloudFunctions from '../../Helpers/cloudFunctions';
const googleProvider = new GoogleAuthProvider();
const twitterProvider = new TwitterAuthProvider()
const facebookProvider = new FacebookAuthProvider()

export default function SignUp() {
    const navigate = useNavigate()
    const EmailPassword = () => {
        const [name, setName] = useState("")
        const [email, setEmail] = useState("")
        const [password, setPassword] = useState("")
        const [error, setError] = useState(null)
        const onSignUp = () => {
            setError(null)
            if (name && email && password) {
                console.log("Running with name, email, password", name, email, password)
                checkForBannedAddress(email, (ok) => {
                    if (ok) {
                        createUserWithEmailAndPassword(auth, email, password).then(async (resultUsr) => {
                            auth.currentUser.reload().then(() => {
                                cloudFunctions.createUser({
                                    email: email,
                                    name: name
                                }).then((result) => {
                                    const response = result.data
                                    if (!response.error) {
                                        updateProfile(resultUsr.user, {
                                            displayName: name
                                        }).then(() => {
                                            window.location.replace("/home")
                                        })
                                    } else {
                                        setError("Somethings went wrong")
                                    }
                                }).catch((err) => {
                                    setError("Something went wrong")
                                })
                            })
                        }).catch((err) => {
                            if (err.code === AuthErrorCodes.EMAIL_EXISTS) {
                                setError("That email already exists")
                            } else if (err.code === AuthErrorCodes.INTERNAL_ERROR) {
                                setError("Something went wrong on our end")
                            } else if (err.code === AuthErrorCodes.WEAK_PASSWORD) {
                                setError("Password too weak")
                            } else {
                                setError(`An unknown error occured (${err.code})`)
                            }
                        })
                    } else {
                        return setError("You can not sign up using a temporary email address")
                    }
                })
            } else {
                setError("Some fields are empty")
            }
        }
        return (
            <div className='signupInputContainer'>
                <input value={name} onChange={(e) => setName(e.target.value)} className='input' type="text" placeholder='Name' />
                <input value={email} onChange={(e) => setEmail(e.target.value)} className='input' type="text" placeholder='Email' />
                <input value={password} onChange={(e) => setPassword(e.target.value)} className='input' type="password" placeholder='Password' />
                <button onClick={onSignUp} className='b5'>Sign Up</button>
                <p style={{ fontWeight: 600, marginTop: 0, marginBottom: 0 }}>Aleady have an account? <span style={{ color: "#0074D9", fontWeight: 700, cursor: "pointer" }} onClick={() => navigate("/login")}>Login</span></p>
                {error
                    ? <div className='error'>
                        <p>{error}</p>
                    </div>
                    : null
                }
            </div>
        )
    }
    const Providers = () => {
        const [error, setError] = useState(null)
        const openPopup = (provider) => {
            signInWithPopup(auth, provider)
                .then((result) => {
                    const displayName = result.user.displayName
                    auth.currentUser.reload().then(() => { 
                        cloudFunctions.createUser({
                            email: result.user.email,
                            name: displayName
                        }).then((result) => {
                            const response = result.data
                            if (!response.error) {
                                updateProfile(auth.currentUser, {
                                    displayName: displayName
                                }).then(() => {
                                    window.location.replace("/home")
                                })
                            } else {
                                setError("Somethings went wrong")
                            }
                        }).catch((err) => {
                            setError("Something went wrong")
                        })
                    })
                })
                .catch((err) => {
                    if (err.code !== AuthErrorCodes.POPUP_CLOSED_BY_USER) {
                        setError(`An unknown error occured (${err.code})`)
                    }
                })
        }
        return (
            <div className='providerButtons'>
                <button onClick={() => openPopup(googleProvider)} className='b3 flex aic' style={{ gap: 13, height: 70, width: "100%" }}>
                    <img src={require("../../Media/GoogleLogo.webp")} style={{ height: 25, width: 25, background: "#fff", padding: 5, borderRadius: "50%" }} alt="Continue with Google" />
                    <p>Continue with Google</p>
                </button>
                <br />
                <button onClick={() => openPopup(twitterProvider)} className='b3 flex aic' style={{ gap: 13, height: 70, width: "100%" }}>
                    <img src={require("../../Media/TwitterLogo.png")} style={{ height: 25, width: 25, background: "#fff", padding: 5, borderRadius: 10, objectFit: "contain" }} alt="Continue with Twitter" />
                    <p>Continue with Twitter</p>
                </button>
                <br />
                <button onClick={() => openPopup(facebookProvider)} className='b3 flex aic' style={{ gap: 13, height: 70, width: "100%" }}>
                    <img src={require("../../Media/FacebookLogo.png")} style={{ height: 25, width: 25, background: "#fff", padding: 5, borderRadius: "50%", objectFit: "cover", backgroundPosition: "center" }} alt="Continue with Twitter" />
                    <p>Continue with Facebook</p>
                </button>
                <br />
                {error
                    ? <div className='error'>
                        <p>{error}</p>
                    </div>
                    : null
                }
            </div>
        )
    }
    return (
        <PageContainer>
            <div style={{ padding: "0 30px" }} className="pgePadd">
                <h1>Create your account</h1>
                <div className='flex jcsb authFlexContainer' style={{ gap: 20, marginTop: 30 }}>
                    <div style={{ flex: 1 }}>
                        <h3 style={{ fontWeight: "bold", marginTop: 0, opacity: .6, fontSize: 20, marginBottom: 20 }}>Signup with Email</h3>
                        <EmailPassword />
                    </div>
                    <div style={{ width: 3, background: "rgba(0,0,0, .1)" }} />
                    <div style={{ flex: 1 }}>
                        <h3 style={{ fontWeight: "bold", marginTop: 0, opacity: .6, fontSize: 20, marginBottom: 20 }}>Signup with Provider</h3>
                        <Providers />
                    </div>
                </div>
            </div>
        </PageContainer>
    )
}
